var map = {
	"./bbtLogo.png": "BVMm",
	"./bg0.png": "zU7D",
	"./docx.png": "vqbK",
	"./excel.png": "c8OG",
	"./file.png": "15x4",
	"./flags.png": "+Tpo",
	"./logo02.png": "yXKp",
	"./pdf.png": "tYfS",
	"./person_icon.png": "COeP",
	"./product_icon.png": "cVVr",
	"./regiterPlayImg.png": "GFfT",
	"./search_icon.png": "XEIH",
	"./test.png": "ZbXH",
	"./tip_icon.png": "nWq1",
	"./txt.png": "xfhl",
	"./user-icon.png": "sTcJ",
	"./word.png": "q6eX",
	"./xlsx.png": "67Zo",
	"./zip.png": "dojJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nDGB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*\.png$
// module id = nDGB
// module chunks = 0